import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CampaignApi } from '../../service/CampaignApi';
import { genders, budgets, languages } from '../Common/DropdownOptions';

export const fetchKeywords = createAsyncThunk('keywords/fetch', async (url: any) => {
  try {
    let targetUrl = url;
    const nextjsUrl = process.env.REACT_APP_NEXTJS_URL;
    let nextjsHost = 'devnextjs.nightlife.net';
    try {
      nextjsHost = new URL(nextjsUrl).hostname;
    } catch (e) { }

    if (url && url.includes(nextjsHost)) {
      const apiUrl = process.env.REACT_APP_API_URL;
      targetUrl = `${apiUrl}/scrape/proxy-media?url=${encodeURIComponent(url)}`;
    }
    const response = await fetch(targetUrl);
    console.log(response, "checkresposneenr");

    const html = await response.text();
    console.log(response, "checkresponsee")
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Use DOM methods to find and extract the content attribute value case-insensitively
    const metaElement = tempDiv.querySelector('meta[name="keywords" i]');
    if (metaElement && metaElement.getAttribute('content')) {
      const keywordsArray = metaElement.getAttribute('content')!.split(',').map((keyword) => keyword && transformKeyword(keyword.trim().replace(/_/g, ' ')));
      return keywordsArray;
    } else {
      throw new Error('META tag with name="Keywords" not found');
    }
  } catch (error) {
    throw Error('Error fetching page source');
  }
});

function transformKeyword(keyword) {
  console.log(keyword);

  if (keyword.includes('video live')) {
    return 'live video';
  }
  if (/^video\d+$/.test(keyword)) {
    return 'video';
  }
  return keyword;
}


function getUniqueKeywords(keywordsArray) {
  const uniqueKeywordsSet = new Set(
    keywordsArray
      .filter(keyword => keyword && keyword.trim() !== '') // Filter out empty strings
      .map(keyword => keyword && keyword.toLowerCase())
  );
  return Array.from(uniqueKeywordsSet);
}
const getCurrentTime = () => {
  const now = new Date();
  const hour = now.getHours();
  const minute = now.getMinutes();
  const period = hour >= 12 ? 'PM' : 'AM';
  return {
    hour: ((hour - 1) % 12) + 1,
    minute: Math.round(minute / 5) * 5,
    period,
  };
};

const AddCampaignSlice = createSlice({
  name: 'campaign',
  initialState: {
    id: null,
    mediaType: null,
    campaignName: null,
    budget_type: budgets[0].value,
    amount: 430,
    age: 18,
    age_to: 65,
    from_duration: new Date(),
    to_duration: new Date(),
    fromTimeValue: getCurrentTime(),
    toTimeValue: { hour: 11, minute: 59, period: 'PM' },
    campaignSettings: null,
    gender: genders[0].value,
    languages: languages[0].name,
    selectedCountries: [{ name: 'All countries', isoCode: 'all' }],
    selectedStates: [],
    selectedCities: [],
    keywords1: [],
    keywords2: [],
    keywords: [],
    tagText: '',
    status: 'idle',
    error: null,
    loading: false,
    colorChange: false
  },

  reducers: {
    setCampaignName: (state, action) => {
      state.campaignName = action.payload;
    },
    setCampaignSettings: (state, action) => {
      state.campaignSettings = action.payload;
    },
    setFromDuration: (state, action) => {
      state.from_duration = action.payload;
    },
    setFromTimeValue: (state, action) => {
      state.fromTimeValue = action.payload;
    },
    setToTimeValue: (state, action) => {
      state.toTimeValue = action.payload;
    },
    setKeywords: (state, action) => {
      return {
        ...state,
        keywords: action.payload
      }
    },
    setKeywords1: (state, action) => {
      state.keywords1 = action.payload;
    },
    addKeyword: (state, action) => {
      const newKeyword = action.payload.trim().replace(/_/g, ' ');
      if (newKeyword) {
        state.keywords.push(newKeyword);
        state.keywords = getUniqueKeywords(state.keywords); // Make sure the keywords are unique
        state.tagText = ''; // Clear the input field after adding the keyword
      }
    },
    setToDuration: (state, action) => {
      state.to_duration = action.payload;
    },
    setSelectedCountries: (state, action) => {
      return {
        ...state,
        selectedCountries: action.payload
      }
    },

    setSelectedStates: (state, action) => {
      return {
        ...state,
        selectedStates: action.payload
      }
    },
    setSelectedCities: (state, action) => {
      return {
        ...state,
        selectedCities: action.payload
      }
    },
    setGender: (state, action) => {
      state.gender = action.payload
    },
    setLanguage: (state, action) => {
      state.languages = action.payload
    },
    setTagText: (state, action) => {
      state.tagText = action.payload;
    },

    setColorChange: (state, action) => {
      state.colorChange = action.payload;
    },

    setAge: (state, action) => {
      state.age = action.payload
    },
    setAgeTo: (state, action) => {
      state.age_to = action.payload
    },
    setBudgetType: (state, action) => {
      state.budget_type = action.payload
    },
    setAmount: (state, action) => {
      state.amount = action.payload
    },
    setNid: (state, action) => {
      state.id = action.payload
    },
    setMediaType: (state, action) => {
      state.mediaType = action.payload
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchKeywords.pending, (state) => {
        state.loading = true;
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchKeywords.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'succeeded';
        state.keywords2 = action.payload;
        // Set the keywords array to the unique combination of keywords1 and keywords2
        state.keywords = getUniqueKeywords(transformKeyword([...state.keywords1, ...state.keywords2]));
      })
      .addCase(fetchKeywords.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addMatcher(CampaignApi.endpoints.getAllCampaigns.matchFulfilled, (state, { payload }) => {
        let keywords: any[] = []
        if (payload.field_video_keywords && payload.field_video_keywords.length > 0) {
          // Assuming field_video_keywords is an array with one element having 'value' property
          keywords = payload.field_video_keywords[0].value.split(',').map((keyword) => keyword && transformKeyword(keyword.trim().replace(/_/g, ' ')));
        }
        if (payload.field_keywords && payload.field_keywords.length > 0) {
          // Assuming field_video_keywords is an array with one element having 'value' property
          keywords = payload?.field_keywords[0]?.value?.split(',').map((keyword) => keyword && transformKeyword(keyword.trim().replace(/_/g, ' ')));
        }
        const locationCity = payload.locations[0]?.city?.trim() || '';
        const campaignType = transformKeyword(payload.type?.trim()?.replace(/_/g, ' ') || '');

        // Create an array to store the keywords including location and campaign type
        let keywordsWithLocation = [...(keywords ?? [])];

        // Create the combined keyword
        const combinedKeyword = locationCity + " " + campaignType;

        // Check if the combined keyword is not empty and doesn't overlap with existing keywords
        const addUniqueKeyword = (keyword) => {
          if (keyword && !keywordsWithLocation.includes(keyword)) {
            keywordsWithLocation.push(keyword);
          }
        }

        // Only add combined keyword if it's unique
        addUniqueKeyword(combinedKeyword.trim());
        return {
          ...state,
          gender: genders[0].value,
          selectedCountries: [{ name: 'All countries', isoCode: 'all' }],
          selectedStates: [],
          selectedCities: [],
          campaignName: payload.title,
          campaignSettings: payload.title,
          keywords1: keywordsWithLocation,
          // Update keywords array only when the fetchKeywords action has already been fulfilled
          keywords: (!state.loading && state.keywords2.length > 0) ? getUniqueKeywords([...keywordsWithLocation, ...state.keywords2]) : getUniqueKeywords(state.keywords)
        }
      })
  }
})


export const { setNid, setAge, setAgeTo, setFromTimeValue, setToTimeValue, setTagText, setLanguage, addKeyword, setFromDuration, setBudgetType, setAmount, setToDuration, setMediaType, setCampaignName, setCampaignSettings, setSelectedCountries, setSelectedStates, setSelectedCities, setGender, setKeywords, setKeywords1, setColorChange } = AddCampaignSlice.actions;

export default AddCampaignSlice.reducer;
